const externalProtocolName = () => {
  switch (location.hostname) {
    case 'localhost':
      return 'Protocolo Externo';
    case 'homologacao.docgo.com.br':
      return 'Protocolo Externo';
    case 'ima.docgo.com.br':
      return 'SEI';
    default:
      return 'Protocolo Externo';
  }
};

export default externalProtocolName;



// WEBPACK FOOTER //
// ./src/utils/external-protocol-name.js